import { render, staticRenderFns } from "./ImageDetails2.vue?vue&type=template&id=464eb3d0"
import script from "./ImageDetails2.vue?vue&type=script&lang=js"
export * from "./ImageDetails2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports